import React from "react";

function Dashboard() {

  return (
    <>
        <div className="items-center w-full duration-300 mx-auto text-[#B7BDC6] md:px-10 px-5 bg-[#0D0D0D]">
          <div className="md:py-32 pt-16 pb-10 max-w-screen-xl mx-auto justify-center">
            <div className="items-center mx-auto lg:grid lg:grid-cols-2">
            <div className="mx-auto justify-center block lg:hidden">
              <svg className="justify-center text-center mx-auto" version="1.0" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 674.000000 655.000000"
                  preserveAspectRatio="xMidYMid meet">
                  <g transform="translate(0.000000,655.000000) scale(0.100000,-0.100000)"
                  fill="#24262C" stroke="none">
                  <path d="M3457 5830 c-161 -19 -364 -86 -505 -167 -343 -198 -569 -509 -659
                  -903 -13 -59 -18 -147 -22 -404 l-6 -329 -60 -13 c-134 -27 -237 -85 -330
                  -185 -30 -33 -55 -64 -55 -70 0 -5 -63 -9 -150 -9 l-150 0 -19 38 c-11 21 -40
                  57 -64 79 -128 119 -324 78 -403 -83 -100 -204 100 -431 316 -359 60 20 125
                  78 153 138 l18 37 102 0 102 0 -3 -352 c-2 -194 -5 -359 -7 -365 -3 -9 -32
                  -13 -99 -13 l-96 0 -19 39 c-80 156 -273 196 -403 82 -120 -106 -120 -286 0
                  -392 133 -116 321 -75 406 89 l17 32 99 0 100 0 -2 -262 -3 -263 -96 -3 -97
                  -3 -22 45 c-60 125 -212 180 -335 122 -56 -26 -119 -90 -142 -145 -53 -123 19
                  -280 154 -338 48 -20 136 -20 186 1 50 22 114 81 138 128 l19 38 100 0 100 0
                  0 -360 0 -360 -99 0 -99 0 -25 43 c-93 157 -288 185 -415 59 -101 -102 -100
                  -265 2 -364 51 -50 100 -71 172 -76 103 -7 204 54 250 151 l15 32 126 -1 126
                  -1 44 -67 c57 -85 137 -155 227 -200 107 -54 169 -66 336 -66 l146 0 52 -124
                  c61 -143 95 -193 158 -235 97 -64 65 -62 885 -59 l744 3 56 28 c103 50 142
                  107 244 349 l15 38 143 0 c162 0 238 14 334 62 78 38 184 134 235 212 l37 58
                  132 2 131 1 19 -37 c26 -51 83 -106 133 -129 47 -21 134 -24 183 -6 134 50
                  209 192 168 321 -70 221 -369 254 -476 51 l-24 -45 -109 0 -108 0 6 31 c3 17
                  6 179 6 360 l0 329 103 0 102 0 24 -46 c63 -119 204 -168 329 -114 121 52 191
                  201 149 317 -21 56 -74 120 -124 150 -41 24 -59 28 -123 28 -52 0 -86 -5 -111
                  -18 -47 -23 -106 -82 -130 -130 l-19 -37 -100 0 -100 0 0 265 0 265 103 0 104
                  0 18 -41 c36 -79 145 -149 231 -149 86 0 194 72 240 160 25 48 25 162 0 210
                  -31 59 -96 119 -154 140 -64 24 -103 25 -168 3 -56 -19 -149 -105 -160 -147
                  -6 -26 -6 -26 -109 -26 l-104 0 -4 338 c-2 185 -8 349 -12 365 l-7 27 115 0
                  c112 0 115 -1 121 -23 10 -40 87 -118 141 -143 74 -35 137 -32 217 9 130 67
                  183 219 119 345 -47 92 -172 162 -263 148 -87 -14 -177 -80 -207 -154 l-13
                  -32 -153 0 -152 0 -29 42 c-69 98 -231 199 -357 221 l-65 11 -5 320 c-5 353
                  -15 426 -78 600 -141 391 -467 706 -856 829 -168 54 -382 76 -546 57z m374
                  -677 c169 -58 315 -185 389 -337 69 -140 73 -166 78 -493 l4 -293 -697 0 -697
                  0 4 303 c4 296 4 304 31 382 61 183 182 322 354 406 113 56 183 69 328 65 102
                  -2 133 -8 206 -33z m1217 -1315 c35 -14 78 -37 97 -50 l35 -23 -198 -6 c-108
                  -3 -198 -6 -199 -7 -1 -1 -70 -85 -154 -187 -83 -102 -155 -187 -159 -190 -5
                  -3 -48 26 -97 65 -112 90 -309 190 -444 224 -416 106 -817 14 -1150 -263 l-36
                  -30 -143 175 c-78 96 -154 184 -168 194 -23 18 -41 20 -214 20 -122 0 -187 4
                  -183 10 13 21 103 66 165 82 60 16 170 17 1425 15 l1360 -2 63 -27z m-2550
                  -412 c78 -96 142 -177 142 -181 0 -3 -25 -41 -55 -84 -30 -44 -78 -127 -106
                  -185 l-51 -106 -279 0 -280 0 3 343 c2 255 6 348 16 365 13 22 15 22 240 22
                  l228 0 142 -174z m2823 142 c10 -24 14 -122 17 -365 l3 -333 -283 1 -283 0
                  -62 127 c-34 70 -81 151 -103 181 -23 29 -39 58 -37 65 5 12 224 285 265 329
                  l26 27 222 0 222 0 13 -32z m-1446 -53 c119 -30 293 -113 385 -183 209 -158
                  359 -396 412 -652 27 -128 21 -385 -11 -502 -106 -385 -396 -675 -781 -780
                  -76 -21 -106 -23 -285 -23 -188 1 -205 3 -290 28 -116 35 -272 112 -355 175
                  -95 71 -228 217 -282 309 -94 159 -145 326 -155 510 -13 244 48 468 181 667
                  163 245 430 421 706 466 41 6 82 13 90 15 8 2 76 2 150 0 102 -3 160 -10 235
                  -30z m-1501 -867 c-5 -40 -9 -127 -9 -193 0 -66 4 -153 9 -192 l8 -73 -256 0
                  -256 0 0 265 0 265 256 0 256 0 -8 -72z m2964 -190 l-3 -263 -255 0 -255 0 1
                  25 c1 14 6 73 12 133 11 101 5 242 -14 335 l-6 32 261 0 261 0 -2 -262z
                  m-2898 -431 c0 -24 81 -181 136 -264 30 -44 54 -89 53 -100 0 -10 -60 -90
                  -133 -178 l-132 -160 -245 0 -244 0 -3 358 -2 357 285 0 c227 0 285 -3 285
                  -13z m2900 -316 c0 -181 -3 -343 -6 -360 l-6 -31 -237 0 -237 0 -140 171 c-76
                  93 -140 174 -142 178 -2 5 26 51 60 102 35 52 81 133 103 182 l39 87 283 0
                  283 0 0 -329z m-2535 -203 c197 -163 435 -262 694 -288 310 -31 649 77 898
                  287 28 23 59 43 70 42 11 0 72 -68 163 -180 80 -100 154 -186 165 -192 14 -8
                  89 -12 233 -12 189 0 212 -2 212 -16 0 -21 -76 -92 -127 -117 -106 -54 -34
                  -52 -1507 -52 -881 0 -1376 4 -1405 11 -97 22 -231 112 -231 155 0 18 12 19
                  219 19 204 0 220 1 241 20 12 11 85 97 163 192 77 95 146 173 152 173 6 0 33
                  -19 60 -42z"/>
                  <path  className="animate-pulse" d="M3270 3012 c0 -4 13 -13 30 -19 17 -6 34 -23 40 -38 6 -16 10 -181
                  10 -425 0 -244 -4 -409 -10 -425 -6 -15 -23 -32 -40 -38 -17 -6 -30 -15 -30
                  -20 0 -5 103 -7 238 -5 182 4 249 9 288 21 111 36 171 111 181 227 5 51 2 67
                  -21 114 -29 58 -83 107 -143 127 -18 6 -33 17 -33 24 0 7 24 27 54 43 105 60
                  152 157 127 259 -21 84 -88 134 -202 153 -74 12 -489 14 -489 2z m440 -43 c97
                  -21 150 -104 135 -214 -9 -70 -41 -122 -95 -153 -41 -25 -56 -27 -167 -31
                  l-123 -3 0 200 c0 183 2 201 18 205 35 9 182 7 232 -4z m8 -454 c71 -21 109
                  -56 127 -118 38 -128 0 -248 -91 -289 -49 -21 -179 -34 -247 -24 l-47 7 0 213
                  c0 117 3 216 7 219 13 13 199 7 251 -8z" fill="#d8bb6c"/>
                  </g>
                </svg>
              </div>
              <div className="items-center duration-500 lg:px-8 mx-auto">
                {/* <div className="w-24 h-0 -ml-28 -mt-16 hidden lg:block">
                  <img src="favicon.png" alt="favicon.png hidden lg:block"/>
                </div> */}
                <div className="items-cente mx-auto">
                  <h1 className="text-[#d8bb6c] md:text-lg md:text-left text-center">Welcome to the</h1>
                  <div className="md:text-left text-center justify-center lg:text-6xl md:text-5xl text-3xl items-center duration-300 text-[#eaecef] font-semibold">
                    <h1>Explore the Vaulteras Coins Tumbler</h1>
                  </div>
                </div>
                <p className="md:pt-5 pt-2 tracking-wider md:text-lg mx-auto text-[#C3CDD3] md:text-left text-center"> Vaulteras help you regain and maintain your anonymity by mixing your cryptos in a pool with other anonymity enthusiasts and receiving untraceable coins using tumbler technology.
                </p>
                <div className="flex gap-8 items-center md:mt-12 mt-8 text-center justify-center md:justify-start">
                  <a 
                    href="/select"
                    className="text-[#d8bb6c] hover:bg-[#d8bb6c] hover:text-black font-bold items-center text-sm md:text-sm grow-0 relative md:h-12 h-10 font-sans px-4 flex border border-[#d8bb6c] rounded-sm uppercase shadow-2xl duration-500">
                      Clean Your BTC Now
                  </a>
                </div>
              </div>
              <div className="mx-auto justify-center hidden lg:block">
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                  width="350.000000pt"viewBox="0 0 674.000000 655.000000"
                  preserveAspectRatio="xMidYMid meet">

                  <g transform="translate(0.000000,655.000000) scale(0.100000,-0.100000)"
                  fill="#24262C" stroke="none">
                  <path d="M3457 5830 c-161 -19 -364 -86 -505 -167 -343 -198 -569 -509 -659
                  -903 -13 -59 -18 -147 -22 -404 l-6 -329 -60 -13 c-134 -27 -237 -85 -330
                  -185 -30 -33 -55 -64 -55 -70 0 -5 -63 -9 -150 -9 l-150 0 -19 38 c-11 21 -40
                  57 -64 79 -128 119 -324 78 -403 -83 -100 -204 100 -431 316 -359 60 20 125
                  78 153 138 l18 37 102 0 102 0 -3 -352 c-2 -194 -5 -359 -7 -365 -3 -9 -32
                  -13 -99 -13 l-96 0 -19 39 c-80 156 -273 196 -403 82 -120 -106 -120 -286 0
                  -392 133 -116 321 -75 406 89 l17 32 99 0 100 0 -2 -262 -3 -263 -96 -3 -97
                  -3 -22 45 c-60 125 -212 180 -335 122 -56 -26 -119 -90 -142 -145 -53 -123 19
                  -280 154 -338 48 -20 136 -20 186 1 50 22 114 81 138 128 l19 38 100 0 100 0
                  0 -360 0 -360 -99 0 -99 0 -25 43 c-93 157 -288 185 -415 59 -101 -102 -100
                  -265 2 -364 51 -50 100 -71 172 -76 103 -7 204 54 250 151 l15 32 126 -1 126
                  -1 44 -67 c57 -85 137 -155 227 -200 107 -54 169 -66 336 -66 l146 0 52 -124
                  c61 -143 95 -193 158 -235 97 -64 65 -62 885 -59 l744 3 56 28 c103 50 142
                  107 244 349 l15 38 143 0 c162 0 238 14 334 62 78 38 184 134 235 212 l37 58
                  132 2 131 1 19 -37 c26 -51 83 -106 133 -129 47 -21 134 -24 183 -6 134 50
                  209 192 168 321 -70 221 -369 254 -476 51 l-24 -45 -109 0 -108 0 6 31 c3 17
                  6 179 6 360 l0 329 103 0 102 0 24 -46 c63 -119 204 -168 329 -114 121 52 191
                  201 149 317 -21 56 -74 120 -124 150 -41 24 -59 28 -123 28 -52 0 -86 -5 -111
                  -18 -47 -23 -106 -82 -130 -130 l-19 -37 -100 0 -100 0 0 265 0 265 103 0 104
                  0 18 -41 c36 -79 145 -149 231 -149 86 0 194 72 240 160 25 48 25 162 0 210
                  -31 59 -96 119 -154 140 -64 24 -103 25 -168 3 -56 -19 -149 -105 -160 -147
                  -6 -26 -6 -26 -109 -26 l-104 0 -4 338 c-2 185 -8 349 -12 365 l-7 27 115 0
                  c112 0 115 -1 121 -23 10 -40 87 -118 141 -143 74 -35 137 -32 217 9 130 67
                  183 219 119 345 -47 92 -172 162 -263 148 -87 -14 -177 -80 -207 -154 l-13
                  -32 -153 0 -152 0 -29 42 c-69 98 -231 199 -357 221 l-65 11 -5 320 c-5 353
                  -15 426 -78 600 -141 391 -467 706 -856 829 -168 54 -382 76 -546 57z m374
                  -677 c169 -58 315 -185 389 -337 69 -140 73 -166 78 -493 l4 -293 -697 0 -697
                  0 4 303 c4 296 4 304 31 382 61 183 182 322 354 406 113 56 183 69 328 65 102
                  -2 133 -8 206 -33z m1217 -1315 c35 -14 78 -37 97 -50 l35 -23 -198 -6 c-108
                  -3 -198 -6 -199 -7 -1 -1 -70 -85 -154 -187 -83 -102 -155 -187 -159 -190 -5
                  -3 -48 26 -97 65 -112 90 -309 190 -444 224 -416 106 -817 14 -1150 -263 l-36
                  -30 -143 175 c-78 96 -154 184 -168 194 -23 18 -41 20 -214 20 -122 0 -187 4
                  -183 10 13 21 103 66 165 82 60 16 170 17 1425 15 l1360 -2 63 -27z m-2550
                  -412 c78 -96 142 -177 142 -181 0 -3 -25 -41 -55 -84 -30 -44 -78 -127 -106
                  -185 l-51 -106 -279 0 -280 0 3 343 c2 255 6 348 16 365 13 22 15 22 240 22
                  l228 0 142 -174z m2823 142 c10 -24 14 -122 17 -365 l3 -333 -283 1 -283 0
                  -62 127 c-34 70 -81 151 -103 181 -23 29 -39 58 -37 65 5 12 224 285 265 329
                  l26 27 222 0 222 0 13 -32z m-1446 -53 c119 -30 293 -113 385 -183 209 -158
                  359 -396 412 -652 27 -128 21 -385 -11 -502 -106 -385 -396 -675 -781 -780
                  -76 -21 -106 -23 -285 -23 -188 1 -205 3 -290 28 -116 35 -272 112 -355 175
                  -95 71 -228 217 -282 309 -94 159 -145 326 -155 510 -13 244 48 468 181 667
                  163 245 430 421 706 466 41 6 82 13 90 15 8 2 76 2 150 0 102 -3 160 -10 235
                  -30z m-1501 -867 c-5 -40 -9 -127 -9 -193 0 -66 4 -153 9 -192 l8 -73 -256 0
                  -256 0 0 265 0 265 256 0 256 0 -8 -72z m2964 -190 l-3 -263 -255 0 -255 0 1
                  25 c1 14 6 73 12 133 11 101 5 242 -14 335 l-6 32 261 0 261 0 -2 -262z
                  m-2898 -431 c0 -24 81 -181 136 -264 30 -44 54 -89 53 -100 0 -10 -60 -90
                  -133 -178 l-132 -160 -245 0 -244 0 -3 358 -2 357 285 0 c227 0 285 -3 285
                  -13z m2900 -316 c0 -181 -3 -343 -6 -360 l-6 -31 -237 0 -237 0 -140 171 c-76
                  93 -140 174 -142 178 -2 5 26 51 60 102 35 52 81 133 103 182 l39 87 283 0
                  283 0 0 -329z m-2535 -203 c197 -163 435 -262 694 -288 310 -31 649 77 898
                  287 28 23 59 43 70 42 11 0 72 -68 163 -180 80 -100 154 -186 165 -192 14 -8
                  89 -12 233 -12 189 0 212 -2 212 -16 0 -21 -76 -92 -127 -117 -106 -54 -34
                  -52 -1507 -52 -881 0 -1376 4 -1405 11 -97 22 -231 112 -231 155 0 18 12 19
                  219 19 204 0 220 1 241 20 12 11 85 97 163 192 77 95 146 173 152 173 6 0 33
                  -19 60 -42z"/>
                  <path className="animate-pulse" d="M3270 3012 c0 -4 13 -13 30 -19 17 -6 34 -23 40 -38 6 -16 10 -181
                  10 -425 0 -244 -4 -409 -10 -425 -6 -15 -23 -32 -40 -38 -17 -6 -30 -15 -30
                  -20 0 -5 103 -7 238 -5 182 4 249 9 288 21 111 36 171 111 181 227 5 51 2 67
                  -21 114 -29 58 -83 107 -143 127 -18 6 -33 17 -33 24 0 7 24 27 54 43 105 60
                  152 157 127 259 -21 84 -88 134 -202 153 -74 12 -489 14 -489 2z m440 -43 c97
                  -21 150 -104 135 -214 -9 -70 -41 -122 -95 -153 -41 -25 -56 -27 -167 -31
                  l-123 -3 0 200 c0 183 2 201 18 205 35 9 182 7 232 -4z m8 -454 c71 -21 109
                  -56 127 -118 38 -128 0 -248 -91 -289 -49 -21 -179 -34 -247 -24 l-47 7 0 213
                  c0 117 3 216 7 219 13 13 199 7 251 -8z" fill="#d8bb6c"/>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default Dashboard